module.exports = __webpack_public_path__ + "static/media/iphone3-2.2789d919.png";